import * as React from 'react';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Link } from "react-router-dom";
import ThemeToggle from '../ThemeToggle';
import Grid from '@mui/material/Grid';


export default function Footer() {
  return (
    <Container maxWidth="md" sx={{padding:1, paddingTop:3, }}>
      <Grid container spacing={2}>
      <Grid item md={6}>
        &copy; 2021-{new Date().getFullYear()} simlsoft
      </Grid>
      <Grid item md={6} sx={{display:'flex'}}>
        <Box component="span" sx={{display:'inline-block', marginLeft:'auto'}}>
         
        <ThemeToggle/></Box>
      </Grid>
      </Grid>
    </Container>
  );
}